import {
  IonButton,
  IonAlert,
  IonModal,
  IonIcon,
  useIonViewWillLeave,
  IonInput,
  IonItem,
  IonLabel,
} from "@ionic/react";
import React, { useEffect, useLayoutEffect, useState } from "react";
import SBoardCalculator from "./components/SBoardCalculator/SBoardCalculator";
import SBoardTimer from "./components/SBoardTimer/SBoardTimer";
import "./ExpandedCard.scss";
import SBoardMessage from "./components/SBoardMessage/SBoardMessage";
import SBoardProvider from "./components/SBoardProvider/SBoardProvider";
import { statusBoardService } from "../../../../StatusBoard.service";
import classNames from "classnames/bind";
import SwapTransferPopup from "./components/SwapTransferPopup/SwapTransferPopup";
import AddEditPatient from "./components/AddEditPatient/AddEditPatient";
import { utilService } from "../../../../../../services/utilService";
import { useToast } from "@agney/ir-toast";
import { CONSTANTS } from "../../../../../../constants";
import NotesContainer from "./components/NotesContainer/NotesContainer";
import Reminder from "./components/Reminder/Reminder";
import { statusBoardSocketService } from "../../../../StatusBoardSocketService";
import GroupSms from "../../../../../../components/Shared/GroupSms/GroupSms";
import NurseCalculator from "../../../../../../components/Shared/NurseCalculator/NurseCalculator";
import { sBoardProviderService } from "./components/SBoardProvider/SBoardProvider.service";
import {
  arrowRedoCircleOutline,
  close,
  refreshCircleOutline,
} from "ionicons/icons";
import _ from "lodash";
import FileShareMediaList from "../../../../../FileShare/components/FileShareMediaList/FileShareMediaList";
import MediaUpload from "../../../../../FileShare/components/MediaUpload/MediaUpload";
import { dataTransferService } from "../../../../../../services/dataTransferService";
import SelectUserComponent from "../../../../../FileShare/components/SelectUserComponent/SelectUserComponent";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import { PatientFormService } from "../../../../../PatientForm/PatientForm.service";
import SelectCaseType from "../../../../../../components/Shared/SelectCaseTypes/SelectCaseType";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  updateTableData: (data: any) => void;
}
const ExpandCard: React.FC<ContainerProps> = (props) => {
const {t} = useTranslation("statusBoard");
  const [showTimerModal, setShowTimerModal] = useState(false); //hide/show modal
  const [showCalculatorModal, setShowCalculatorModal] = useState(false); //hide/show modal
  const [showMessageModal, setshowMessageModal] = useState(false);
  const [showProviderModal, setshowProviderModal] = useState(false);
  const [showSwapTransferPopup, setSwapTransferPopup] = useState(false);
  const [showAddEditPatientPopup, setAddEditPatientPopup] = useState(false);
  const [inputParams, setInputParams] = useState<Object>();
  const [showAlert, setShowAlert] = useState(false);
  const [showGroupSmsModal, setShowGroupSmsModal] = useState(false);
  const [showNurseCalculatorModal, setShowNurseCalculatorModal] =
    useState(false);

  const [selectedGuid, setSelectedGuid]: any = useState([]);
  const [selectedUserName, setSelectedName]: any = useState([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowMediaListModal, setIsShowMediaListModal] = useState(false);
  const [isShowUploadMediaModal, setIsShowUploadMediaModal] = useState(false);
  const [isShowSelectUserModal, setIsShowSelectUserModal] = useState(false);
  const [isNotesUpdated, setIsNotesUpdated] = useState(false);
  const [isReminderUpdated, setIsReminderUpdated] = useState(false);
  const [doctorData, setDoctorData]: any = useState([]);
  const [addToEmergency, setAddToEmergency] = useState(false);
  const [showSignInAlert, setShowSignInAlert] = useState(false);
  const [dataFromParentComponent, setDataFromParentComponent]: any = useState(
    []
  );
  const [userName, setUserName] = useState<string>("");
  const [isInvalidCredentials, setSignInValidations] = useState(false);
  const [isShowPassword, setPasswordStatus] = useState(false);
  const [userPassword, setUserPassword] = useState<string>("");
  const [isFormValid, setFormStatus] = useState(false);
  const [selectPatient, isSelectPatient] = useState(false);
  const [EMTTypes, getEMTTypes] = useState([]);
  const [isCustomType, enableCustomType] = useState(false);
  const [selectedType, setSelectedType] = useState<any>(0);
  const [selectedTypeName, setSelectedTypeName]: any = useState();
  const [selectedPatientId, setSelectedPatient] = useState();
  const [isPatientInEmergency, checkPatientInEmergency] = useState(false);

  const [showSelectProviderModal, setShowSelectProviderModal]: any =
    useState(false);
  const [selectedProvidersNames, setSelectedProvidersNames] = useState([]);
  const [selectedCaseTypeList, setSelectedCaseTypeList]: any = useState([]);
  const [disableAddButton, setDisableAddButton] = useState(true);
  const [showSignInAlertForNote, setShowSignInAlertForNote] = useState(false);
  const [refreshBtnClick, setRefreshBtnClick] = useState(false);

  const location = useLocation();
  const Toast = useToast();
  let history = useHistory();

  useEffect(() => {
    setFormStatus(formValidation());
  }, [userName, userPassword]);

  useEffect(() => {
    getTypesList();
  }, []);

  const formValidation = () => {
    return userName && userPassword ? true : false;
  };

  const getTypesList = async () => {
    let params = {};
    const getTypesList: any = await PatientFormService.getTypesList(params);
    if (getTypesList.isSuccess) {
      getEMTTypes(getTypesList.result);
    } else {
      console.log("error");
    }
  };

  const OnGroupSmsBtnClick = () => {
    const doctorData = sBoardProviderService.getDoctorListDataFromComponent();
    setDoctorData(doctorData);
    setShowGroupSmsModal(true);
  };

  useIonViewWillLeave(() => {
    statusBoardSocketService.closeSbInputSocketConnection();
  });

  useEffect(() => {
    initaiteSbInputSocketConnection();
    return () => {
      statusBoardSocketService.closeSbInputSocketConnection();
    };
  }, []);

  const initaiteSbInputSocketConnection = () => {
    const patientDetails = statusBoardService.rowData;
    const socketParams = {
      sbId: location.pathname?.split("/")[3],
      patientId: patientDetails.pid,
    };
    statusBoardSocketService.getStatusBoardInputConnection(socketParams);
  };

  // Web socket observables  subscription starts here
  useLayoutEffect(() => {
    let sub = dataTransferService.getNotesListAction.subscribe((data: any) => {
      if (!_.isEmpty(data)) {
        setIsNotesUpdated(true);
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getReminderListAction.subscribe(
      (data: any) => {
        if (!_.isEmpty(data)) {
          setIsReminderUpdated(true);
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  // Web socket observables subscription ends here

  useLayoutEffect(() => {
    let sub = dataTransferService.getReplyMediaAction.subscribe((data: any) => {
      if (!_.isEmpty(data)) {
        setIsShowMediaListModal(false);
        setIsShowUploadMediaModal(true);
        setIsShowSelectUserModal(false);
        setDataFromParentComponent(data);
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getForwardMediaAction.subscribe(
      (data: any) => {
        if (!_.isEmpty(data)) {
          setIsShowMediaListModal(false);
          setIsShowUploadMediaModal(false);
          setIsShowSelectUserModal(true);
          setDataFromParentComponent(data);
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const rowData = statusBoardService.rowData;
  const movePatientType = CONSTANTS.MOVE_PATIENT;

  const onCancelSwapTransfer = (status: boolean) => {
    setSwapTransferPopup(false);
    if (status) {
      updateTable();
    }
  };
  const onCancelAddEditPatient = (status: boolean) => {
    setAddEditPatientPopup(false);
    if (status) {
      updateTable();
    }
  };

  const updateTable = (isPrimaryMDUpdated?: boolean) => {
    const data = {
      isSbButtonUpdate: true,
      isPrimaryMDUpdated,
      rowId: rowData && rowData.id ? rowData.id : "",
    };
    props.updateTableData(data);
  };
  const openSwapTransferPopup = (type: any) => {
    const params = {
      patientData: rowData,
      changeType: type,
      unitDetails: statusBoardService.statusBoardData
        ? statusBoardService.statusBoardData
        : [],
    };
    setInputParams(params);
    setSwapTransferPopup(true);
  };

  const addEditPatient = () => {
    setAddEditPatientPopup(true);
  };

  const dischargePatient = () => {
    checkIfPatientUnderEmergency();
  };

  const checkIfPatientUnderEmergency = async () => {
    const date: any = new Date();
    const params = {
      bid: rowData.id,
      reg_code: utilService.getNetwork(),
    };
    const respResult: any = await statusBoardService.checkIfEmergencyCompleted(
      params
    );
    if (respResult.isSuccess) {
      if (!respResult.result.discharge_status) {
        Toast.error(respResult.message);
      } else {
        setShowAlert(true);
      }
    }
  };
  const proceedDischarge = async () => {
    const date: any = new Date();
    const params = {
      action_username: userName,
      action_password: userPassword,
      bid: rowData.id,
      datetime: utilService.getFullDate(date),
      reg_code: utilService.getNetwork(),
    };
    const respResult: any = await statusBoardService.dischargePatient(params);
    if (respResult.isSuccess) {
      // if(!respResult.result.discharge_status){
      //   Toast.error(respResult.message)
      // }
      // else{
      // Toast.success(CONSTANTS.MESSAGES.DISCHARGE_SUCCESS);
      const socketParams = {
        socketType: CONSTANTS.SOCKET_TYPE.DISCHARGE,
        bedId: rowData.id,
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
      updateTable();
      Toast.success("Patient discharged successfully");
      // }
    } else {
      // Toast.error(respResult?.message);
      setSignInValidations(true);
    }
  };

  const onShowPassword = () => {
    setPasswordStatus(!isShowPassword);
  };

  const updateProviderDetails = (status: boolean) => {
    if (status) {
      updateTable();
    }
    setshowProviderModal(false);
  };

  const onMediaInboxClicked = () => {
    setSelectedGuid(rowData.pid);
    setSelectedName(rowData.patient.value);
    setIsShowModal(true);
    setIsShowMediaListModal(true);
  };

  const addPatientToEmergency = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      patient_id: rowData.pid,
      in_patient: true,
      case_type_list: selectedCaseTypeList,
      case_type_name: selectedTypeName,
      action_username: userName,
      action_password: userPassword,
    };
    inPatientEmergency(addParams);
  };

  async function inPatientEmergency(addParams: any) {
    const respTimer: any = await statusBoardService.inPatientEmergency(
      addParams
    );
    if (respTimer.isSuccess) {
      Toast.success("Patient added to emergency");
      setShowSignInAlert(false);
      enableRedirect();
    } else {
      statusBoardService.handleErrorResponse();
      setSignInValidations(true);
    }
  }

  const enableEmergencyButton = () => {
    isSelectPatient(true);
    setSelectedProvidersNames([]);
    enableCustomType(false);
    setSelectedTypeName("");
  };

  const enableRedirect = () => {
    setTimeout(() => {
      history.push({
        pathname: "/client/case-history",
        state: { patientId: rowData?.patient?.patient_id, inPatient: true },
      });
    }, 400);
  };

  const setCustomCaseType = (selectedCase: any) => {
    setSelectedType(0);
    setSelectedTypeName(selectedCase.target.value);
  };

  const getSelectedProvidersList = (CaseListArrayList: any) => {
    let caseTypeIds = CaseListArrayList.map((item: any) => {
      if (item.is_selected === true) {
        return item.id;
      }
    });

    let caseTypeNames = CaseListArrayList.map((item: any) => {
      if (item.is_selected === true) {
        return item.case;
      }
    });

    let caseLists = caseTypeIds.filter(function (element: any) {
      return element !== undefined;
    });

    let caseNameLists = caseTypeNames.filter(function (element: any) {
      return element !== undefined;
    });

    setSelectedCaseTypeList(caseLists);
    checkOtherCaseTypeSelected(caseLists);
    setSelectedProvidersNames(caseNameLists);
    if (caseNameLists.length !== 0) {
      setDisableAddButton(false);
    } else {
      setDisableAddButton(true);
    }
  };

  const checkOtherCaseTypeSelected = (caseTypeList: any) => {
    const isOtherSelected = caseTypeList.includes(0);
    enableCustomType(isOtherSelected);
  };

  return (
    <div className="expand-card-container">
      <div className="card-header-container">
        <ul className="flex-left-content">
          <li
            onClick={() => {
              dischargePatient();
            }}
            id="patientBtn"
            className={classNames({
              "discharge-btn": true,
              "no-display ": rowData?.pid !== " " ? false : true,
            })}
          >
           {t("dischargePatient")}
          </li>
          <li
            onClick={() => addEditPatient()}
            id="patientBtn"
            className={classNames({ "green-btn": true })}
          >
           {rowData?.pid !== " " ? t("editPatient") : t("admitPatient")}
          </li>
          <li
            id="swapBtn"
            onClick={() => openSwapTransferPopup(movePatientType?.SWAP)}
            className={classNames({
              "sb-btn": true,
              "disable-content ": rowData?.pid === " " ? true : false,
            })}
          >
            <i className="icon-swap"> </i>{t("swap")}
          </li>
          <li
            id="transferBtn"
            onClick={() => openSwapTransferPopup(movePatientType?.TRANSFER)}
            className={classNames({
              "sb-btn": true,
              "disable-content ": rowData?.pid === " " ? true : false,
            })}
          >
            <i className="icon-transfer"> </i>{t("transfer")}
          </li>
          <li
            id="emergencyBtn"
            onClick={() => {
              if (!rowData?.patient?.added_to_emergency) {
                setAddToEmergency(true);
                setDisableAddButton(true);
              } else {
                Toast.error("Patient is already in emergency");
              }
            }}
            className={classNames({
              "sb-btn": true,
              "disable-content": rowData?.pid === " " ? true : false,
              "disable-emergency-button": rowData?.patient?.added_to_emergency
                ? true
                : false,
            })}
          >
            {t("emergency")}
          </li>
          <li
            id="redirectBtn"
            onClick={() => {
              history.push({
                pathname: "/client/case-history",
                state: {
                  patientId: rowData?.patient?.patient_id,
                  inPatient: true,
                },
              });
            }}
            className={classNames({
              "sb-btn": true,
              "disable-content":
                rowData?.pid === " " ? true : false ? true : false,
            })}
          >
            <IonIcon
              icon={arrowRedoCircleOutline}
              className="emergencyRedirect"
            ></IonIcon>
          </li>
          {/* <li
            id="refreshBtn"
            onClick={() => {
              setRefreshBtnClick(true);
            }}
            className={classNames({
              "sb-btn": true,
              "disable-content":
                rowData?.pid === " " ? true : false ? true : false,
            })}
          >
            <IonIcon
              icon={refreshCircleOutline}
              className="emergencyRedirect"
            ></IonIcon>
          </li> */}
        </ul>
        <div className="flex-right-content">
          <ul>
            <li
              id="mediaInboxBtn"
              className="media-inbox-btn"
              onClick={() => onMediaInboxClicked()}
            >
             {t("mediaInbox")}
            </li>
            <li
              title="Calculator"
              id="showCalculatorBtn"
              onClick={() => setShowCalculatorModal(true)}
              className="showCalculatorBtn"
            >
              <div className="input-icon icon-calculate"></div>
            </li>
            <li
              title="Timer"
              id="showTimerBtn"
              onClick={() => setShowTimerModal(true)}
              className="showTimerBtn"
            >
              <div className="input-icon icon-time"></div>
            </li>
            <li
              id="groupSmsBtn"
              className={`group-sms-btn ${
                rowData?.pid == " " ? "disabled" : ""
              }`}
              onClick={() => OnGroupSmsBtnClick()}
            >
              {t("groupSms")}
            </li>
            <li
              id="nurseCalculatorBtn"
              className="nurse-calculator-btn"
              onClick={() => {
                setShowNurseCalculatorModal(true);
              }}
            >
              <i className="input-icon icon-calculate"></i>
              <span className="nurse-calculator-label">   {t("nurseCalculator")}</span>
            </li>
          </ul>
        </div>

        <IonAlert
          isOpen={addToEmergency}
          onDidDismiss={() => {
            setAddToEmergency(false);
          }}
          cssClass="fav-delete-alert"
          header={t("confirmationMessage")}
message={t("startEmergency")}
          buttons={[
            {
             text: t("no"),
              role: "cancel",
              cssClass: "secondary",
            },
            {
              text: t("ok"),
              handler: () => {
                // setShowSignInAlert(true);
                enableEmergencyButton();
              },
            },
          ]}
        />

        <IonModal
          isOpen={showSignInAlert}
          backdropDismiss={false}
          className="add-fav-modal sb-fav-modal sign-In-modal"
        >
          <div className="label-div">
          <div className="label-name">{t("signIn")}</div>
            <div
              className="input-icon icon-close"
              onClick={() => {
                setShowSignInAlert(false);
              }}
            ></div>
          </div>
          <form className="sign-in-input-container" autoComplete="off">
            <div className="signin-input-wrapper">
              <IonItem className="item-input">
                <IonLabel className="item-label" position="floating">
                  {t("username")}
                </IonLabel>
                <IonInput
                  className="ion-input"
                  name="username"
                  type="search"
                  value={userName}
                  onIonChange={(event) => {
                    setUserName(event.detail.value!);
                    setSignInValidations(false);
                  }}
                  autocomplete="off"
                  maxlength={25}
                >
                  {" "}
                </IonInput>
              </IonItem>
            </div>
            <div className="signin-input-wrapper">
              <div
                className={`input-icon clickable ${
                  isShowPassword ? "icon-show_password" : "icon-hide_password"
                }`}
                onClick={onShowPassword}
              ></div>
              <IonItem className="item-input">
                <IonLabel className="item-label" position="floating">
                  {t("password")}
                </IonLabel>
                <IonInput
                  className="ion-input"
                  type={isShowPassword ? "text" : "password"}
                  name="password"
                  value={userPassword}
                  onIonChange={(event) => {
                    setUserPassword(event.detail.value!);
                    setSignInValidations(false);
                  }}
                  autocomplete="new-password"
                >
                  {" "}
                </IonInput>
              </IonItem>
            </div>
            <div className="signin-validations" hidden={!isInvalidCredentials}>
              {t("invalidCredentials")}
            </div>
          </form>

          <div className="add-fav-button-container">
            <div className="cancel-button-div sign-in-btn">
              <IonButton
                color="medium"
                className="button secondary-btn  btn-curved"
                onClick={() => {
                  setUserName("");
                  setUserPassword("");
                }}
              >
                {t("clear")}
              </IonButton>
            </div>
            <div className="send-button-div sign-in-btn">
              <IonButton
                disabled={!isFormValid}
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  addPatientToEmergency();
                }}
              >
              {t("signIn")}
              </IonButton>
            </div>
          </div>
        </IonModal>

        <SBoardTimer
          showModal={showTimerModal}
          onCancel={() => {
            setShowTimerModal(false);
          }}
        />
        <SBoardCalculator
          showModal={showCalculatorModal}
          onCancel={() => {
            setShowCalculatorModal(false);
          }}
        />
        <GroupSms
          showModal={showGroupSmsModal}
          doctorListDataFromParent={doctorData}
          onOk={() => {
            setShowGroupSmsModal(false);
          }}
          onCancel={() => {
            setShowGroupSmsModal(false);
          }}
        ></GroupSms>
        <NurseCalculator
          showModal={showNurseCalculatorModal}
          onCancel={() => {
            setShowNurseCalculatorModal(false);
          }}
        ></NurseCalculator>
      </div>
      <div
        className={classNames({
          "card-input-container": true,
          "disable-content ": rowData?.pid === " " ? true : false,
        })}
      >
        <div className="provider-wrapper-col">
          <SBoardProvider
            showModal={showProviderModal}
            onCancel={updateProviderDetails}
            refreshEnabled={refreshBtnClick}
          ></SBoardProvider>
        </div>
        <div className="reminders-wrapper-col">
          <Reminder
            isReminderUpdated={isReminderUpdated}
            onReminderUpdated={() => {
              setIsReminderUpdated(false);
            }}
          />
        </div>
        <div className="notes-wrapper-col">
          <NotesContainer
            isNotesUpdated={isNotesUpdated}
            onNotesUpdated={() => {
              setIsNotesUpdated(false);
            }}
          />
        </div>
        <div className="msg-wrapper-col">
          <SBoardMessage
            showModal={showMessageModal}
            onCancel={() => {
              setshowMessageModal(false);
            }}
          />
        </div>
      </div>

      {showSwapTransferPopup && (
        <SwapTransferPopup
          showModal={showSwapTransferPopup}
          inputData={inputParams}
          onCancel={onCancelSwapTransfer}
        ></SwapTransferPopup>
      )}
      {showAddEditPatientPopup && (
        <AddEditPatient
          showModal={showAddEditPatientPopup}
          patientData={rowData}
          statusBoardData={
            statusBoardService.statusBoardData
              ? statusBoardService.statusBoardData
              : []
          }
          onCancel={onCancelAddEditPatient}
        ></AddEditPatient>
      )}

      <IonModal
        isOpen={selectPatient}
        backdropDismiss={false}
        className="emergency-patient"
      >
        <div className="label-div">
          <div className="label-name">{t("emergency")}</div>
        </div>

        <form className="case-details-edit-modal">
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label className="ems-form-label">{t("selectCaseTypes")}</label>
              <IonItem className="select-schedule-wrapper">
                <IonInput
                  readonly
                  className="schedule-input"
                  onClick={() => setShowSelectProviderModal(true)}
                  value={
                    selectedProvidersNames[0] === "ALL" ||
                    selectedProvidersNames.length === 0
                      ? "Select case types"
                      : selectedProvidersNames.join()
                  }
                ></IonInput>
              </IonItem>

              <SelectCaseType
                showModal={showSelectProviderModal}
                onOk={() => {
                  setShowSelectProviderModal(false);
                }}
                ListData={EMTTypes}
                isAllSelected={false}
                onCancel={() => {
                  setShowSelectProviderModal(false);
                }}
                getSelectedProviders={getSelectedProvidersList}
                isFromStatusboard={true}
              />
            </div>
            <div className="col-md-12 mb-3" hidden={!isCustomType}>
              {isCustomType && (
                <>
                  <label className="ems-form-label">{t("otherCaseType")}</label>

                  <input
                    type="text"
                    className="form-control custom-type emt-sac-input"
                    id="field-1"
                    maxLength={26}
                placeholder={t("enterOtherCaseType")}
                    value={selectedTypeName}
                    onChange={(selectedCase: any) =>
                      setCustomCaseType(selectedCase)
                    }
                  />
                </>
              )}
            </div>
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                isSelectPatient(false);
                setSelectedPatient(undefined);
                setSelectedTypeName("");
                enableCustomType(true);
              }}
            >
              {t("cancel")}
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                if (!isPatientInEmergency) {
                  isSelectPatient(false);
                  setShowSignInAlert(true);
                } else {
                  Toast.error("Patient is already in emergency");
                }
              }}
              disabled={disableAddButton}
            >
              {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>

      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        cssClass=""
        header={CONSTANTS.MESSAGES.DISCHARGE_CONFIRMATION.TITLE}
        message={CONSTANTS.MESSAGES.DISCHARGE_CONFIRMATION.MESSAGE}
        buttons={[
          {
            text: "No",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
              setShowAlert(false);
            },
          },
          {
            text: "Yes",
            handler: () => {
              setShowSignInAlertForNote(true);
            },
          },
        ]}
      />

      <IonModal
        isOpen={isShowModal}
        backdropDismiss={false}
        className="media-list-modal"
      >
        <div className="media-list-modal-container">
          <div
            className="close-modal-icon"
            onClick={() => {
              setIsShowModal(false);
              setIsShowSelectUserModal(false)
            }}
          >
            <IonIcon icon={close} />
          </div>
          {isShowMediaListModal && (
            <div className="attach-media-content">
              <FileShareMediaList
                selectedUserGuid={selectedGuid}
                selectedPatientId={selectedGuid}
                selectedUserName={selectedUserName}
                isStatusBoard={true}
                onUploadButtonClicked={() => {
                  setIsShowMediaListModal(false);
                  setIsShowUploadMediaModal(true);
                  setIsShowSelectUserModal(false);
                }}
                isSmallScreen={true}
              ></FileShareMediaList>
            </div>
          )}
          {isShowUploadMediaModal && (
            <div className="attach-media-content">
              <MediaUpload
                isGroupMediaShare={true}
                doctorListDataFromParent={selectedGuid}
                dataFromParentComponent={dataFromParentComponent}
                isNotificationCard={true}
                isStatusBoard={true}
                onOk={() => {}}
                onCancel={() => {
                  setIsShowMediaListModal(true);
                  setIsShowSelectUserModal(false);
                  setIsShowUploadMediaModal(false);
                }}
                isSmallScreen={true}
              ></MediaUpload>
            </div>
          )}
          {isShowSelectUserModal && (
            <SelectUserComponent
              isModalPopUpScreen={true}
              onCancel={() => {
                setIsShowSelectUserModal(false);
                setIsShowMediaListModal(true);
              }}
              dataFromParentComponent={dataFromParentComponent}
              getSelectedCard={() => {}}
            ></SelectUserComponent>
          )}
        </div>
      </IonModal>

      <IonModal
        isOpen={showSignInAlertForNote}
        backdropDismiss={false}
        className="add-fav-modal sb-fav-modal sign-In-modal"
      >
        <div className="label-div">
          <div className="label-name">Sign In</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowSignInAlertForNote(false);
            }}
          ></div>
        </div>
        <form className="sign-in-input-container" autoComplete="off">
          <div className="signin-input-wrapper">
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                Username
              </IonLabel>
              <IonInput
                className="ion-input"
                name="username"
                type="search"
                value={userName}
                onIonChange={(event) => {
                  setUserName(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="off"
                maxlength={25}
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-input-wrapper">
            <div
              className={`input-icon clickable ${
                isShowPassword ? "icon-show_password" : "icon-hide_password"
              }`}
              onClick={onShowPassword}
            ></div>
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                Password
              </IonLabel>
              <IonInput
                className="ion-input"
                type={isShowPassword ? "text" : "password"}
                name="password"
                value={userPassword}
                onIonChange={(event) => {
                  setUserPassword(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="new-password"
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-validations" hidden={!isInvalidCredentials}>
            Invalid username or password
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setUserName("");
                setUserPassword("");
              }}
            >
              Clear
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              disabled={!isFormValid}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setShowAlert(false);
                proceedDischarge();
              }}
            >
              Sign In
            </IonButton>
          </div>
        </div>
      </IonModal>
    </div>
  );
};

export default ExpandCard;
